const backgroundUrl = (url: string) => `url(${url})})`

export default backgroundUrl
